var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "captcha" }, [
    _vm.img
      ? _c("img", {
          staticClass: "captcha__image",
          attrs: { src: "data:image/png;base64," + _vm.img },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "captcha__holder" },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.captchaResult,
              expression: "captchaResult",
            },
          ],
          staticClass: "captcha__input",
          attrs: { type: "text" },
          domProps: { value: _vm.captchaResult },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.captchaResult = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "tile-button",
          {
            nativeOn: {
              click: function ($event) {
                return _vm.updateWidthCaptcha.apply(null, arguments)
              },
            },
          },
          [_vm._v("Отправить")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }